var map = {
	"./10-1.png": "d2a1",
	"./11-1.png": "33f4",
	"./12-1.png": "bf41",
	"./7-1.png": "a415",
	"./8-1.png": "43f0",
	"./9-1.png": "5ace",
	"./piece/1-1.png": "3ee4",
	"./piece/2-1.png": "0190",
	"./piece/3-1.png": "0ef7",
	"./piece/4-1.png": "828a",
	"./piece/5-1.png": "dc45",
	"./piece/6-1.png": "cd0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4783";